<script lang="ts">
  import type { Color } from '@athena-lib/colors';
  import { Text } from '@athena-lib/Text';
  import clsx from 'clsx';
  import type { Snippet } from 'svelte';

  type BannerVariant = 'informative' | 'success' | 'error';

  type BannerProps = {
    variant?: BannerVariant;
    icon?: Snippet;
    title: string;
    content: Snippet<[BannerVariant, Color]>;
    class?: string;
  };

  const { variant = 'informative', icon, title, content, class: className }: BannerProps = $props();

  const { textColor, iconClass, cardClass } = $derived.by(() => {
    if (variant === 'error') {
      return {
        iconClass: 'text-st-red-700',
        cardClass: 'bg-st-red-100 border-st-red-500',
        textColor: 'dark-red',
      } as const;
    }

    if (variant === 'success') {
      return {
        iconClass: 'text-st-green-700',
        cardClass: 'bg-st-green-100 border-st-green-500',
        textColor: 'dark-green',
      } as const;
    }

    return {
      iconClass: 'text-st-gray-700',
      cardClass: 'bg-st-gray-100 border-st-gray-500',
      textColor: 'dark',
    } as const;
  });
</script>

<div role="alert" class={clsx('flex w-full gap-3 rounded border-2 p-6', cardClass, className)}>
  {#if icon}
    <div class={iconClass}>
      {@render icon()}
    </div>
  {/if}
  <div class="flex flex-1 flex-col gap-1">
    <Text element="span" color={textColor} bold>{title}</Text>
    {@render content(variant, textColor)}
  </div>
</div>
